import type { ClientBasedAuth } from '@atlaskit/media-core/auth';
import { ObjectRecorder } from '../src/ObjectRecorder.ts';

export const mediaConfigRecorder: ObjectRecorder<ClientBasedAuth> =
	new ObjectRecorder<ClientBasedAuth>();
export const jiraMediaConfigRecorder: ObjectRecorder<ClientBasedAuth> =
	new ObjectRecorder<ClientBasedAuth>();
export const mediaConfigEnforceDSPRecorder: ObjectRecorder<boolean> = new ObjectRecorder<boolean>();
export const mediaNodesRecorder: ObjectRecorder<ReadonlyArray<unknown>> = new ObjectRecorder<
	ReadonlyArray<unknown>
>();
